import React from 'react';

import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

import { Menu, MenuItem } from '@mui/material';

import { RuleCombinator as Combinator } from 'utils/api/modules/memberGroups';

import { ConditionJoin, JoinLabel, JoinToggle } from './styles';

export interface RuleCombinatorProps {
  combinator: Combinator;
  onChange: (combinator: Combinator) => void;
  interactive: boolean;
}

const word = (combinator: Combinator): string => (combinator === Combinator.All ? 'and' : 'or');

const RuleCombinator: React.FunctionComponent<RuleCombinatorProps> = ({ combinator, onChange, interactive }) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  if (!interactive) {
    return (
      <ConditionJoin>
        <JoinLabel>{word(combinator)}</JoinLabel>
      </ConditionJoin>
    );
  }

  const close = (): void => setAnchorEl(null);
  const select = (value: Combinator): void => {
    onChange(value);
    close();
  };

  return (
    <ConditionJoin>
      <JoinToggle
        type="button"
        aria-label="Match all or any of the conditions"
        aria-haspopup="menu"
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        {word(combinator)}
        <ArrowDropDownIcon fontSize="small" />
      </JoinToggle>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={close}>
        <MenuItem selected={combinator === Combinator.All} onClick={() => select(Combinator.All)}>
          and
        </MenuItem>
        <MenuItem selected={combinator === Combinator.Any} onClick={() => select(Combinator.Any)}>
          or
        </MenuItem>
      </Menu>
    </ConditionJoin>
  );
};

export default RuleCombinator;
